export const DIRECTION_COLOURS: Record<string, string> = {
  outbound: 'bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-400',
  inbound: 'bg-green-100 text-green-700 dark:bg-green-950/50 dark:text-green-400',
}

export const TYPE_COLOURS: Record<string, string> = {
  email: 'bg-purple-100 text-purple-700 dark:bg-purple-950/50 dark:text-purple-400',
  letter: 'bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-400',
  phone: 'bg-cyan-100 text-cyan-700 dark:bg-cyan-950/50 dark:text-cyan-400',
  meeting: 'bg-rose-100 text-rose-700 dark:bg-rose-950/50 dark:text-rose-400',
}
